import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";

const DEFAULT_SLIDES = [
  ["/images/udaipur/pool.jpg", "Swimming pool at The Ananta Udaipur"],
  ["/images/udaipur/aerial.jpg", "Aerial view of The Ananta Udaipur in the Aravalli Hills"],
  ["/images/udaipur/float.jpg", "Poolside at The Ananta Udaipur"],
  ["/images/udaipur/lobby.jpg", "Lobby facade at The Ananta Udaipur"],
  ["/images/udaipur/suite1.jpg", "Suite interior at The Ananta Udaipur"],
  ["/images/udaipur/dining.jpg", "Outdoor dining at The Ananta Udaipur"],
];

const Arrow = ({ dir, onClick }) => (
  <button aria-label={dir < 0 ? "Previous photo" : "Next photo"} onClick={onClick} data-testid={`hero-slider-${dir < 0 ? "prev" : "next"}`}
    className="h-10 w-10 sm:h-11 sm:w-11 border border-white/50 text-white flex items-center justify-center bg-black/20 backdrop-blur-sm transition-colors hover:bg-white hover:text-[#1E3B2E]">
    {dir < 0 ? <ChevronLeft size={18} /> : <ChevronRight size={18} />}
  </button>
);

export default function HeroSlider({ images }) {
  const SLIDES = images?.length ? images.slice(0, 8).map((src) => [src, "The Ananta Udaipur"]) : DEFAULT_SLIDES;
  const [i, setI] = useState(0);
  const go = (d) => setI((v) => (v + d + SLIDES.length) % SLIDES.length);
  useEffect(() => {
    const t = setTimeout(() => go(1), 6000);
    return () => clearTimeout(t);
  }, [i]);


  return (
    <div className="absolute inset-0 overflow-hidden" data-testid="hero-slider">
      <AnimatePresence initial={false}>
        <motion.img key={i} src={SLIDES[i % SLIDES.length][0]} alt={SLIDES[i % SLIDES.length][1]} draggable={false}
          className="absolute inset-0 h-full w-full object-cover object-center select-none"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 1.1 }}
          drag="x" dragConstraints={{ left: 0, right: 0 }} dragElastic={0.15}
          onDragEnd={(_, info) => { if (Math.abs(info.offset.x) > 50) go(info.offset.x < 0 ? 1 : -1); }}
          fetchPriority={i === 0 ? "high" : "auto"} data-testid="hero-slide-image" />
      </AnimatePresence>
      <div className="absolute inset-0 pointer-events-none bg-gradient-to-b from-black/40 via-transparent to-black/30 lg:hidden" />
      <div className="absolute inset-0 hero-shade pointer-events-none hidden lg:block" />
      <div className="absolute z-10 right-4 sm:right-10 bottom-4 lg:bottom-auto lg:top-1/2 lg:-translate-y-1/2 flex lg:flex-col gap-2 sm:gap-3">
        <Arrow dir={-1} onClick={() => go(-1)} />
        <Arrow dir={1} onClick={() => go(1)} />
      </div>
      <div className="absolute z-10 left-5 bottom-8 lg:left-auto lg:bottom-auto lg:right-10 lg:top-24 flex gap-2" data-testid="hero-slider-dots">
        {SLIDES.map((s, n) => (
          <button key={s[0]} aria-label={`Show photo ${n + 1}`} onClick={() => setI(n)} data-testid={`hero-slider-dot-${n}`}
            className={`h-[3px] transition-[width,background-color] duration-500 ${n === i ? "w-8 sm:w-10 bg-[#C28B5E]" : "w-4 sm:w-5 bg-white/60 hover:bg-white"}`} />
        ))}
      </div>
    </div>
  );
}
